// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"InnovationFuture_sectionContainer__bRAvj","description":"InnovationFuture_description__sy7yg"};